<div class="{{className}}">
  <ckeditor [disabled]="isDisabled" [editor]="editor" data="{{paragraph}}" (change)="onChange($event)"></ckeditor>
</div>